import { __assign } from "tslib";
import { isa as __isa } from "@aws-sdk/smithy-client";
export var AmbiguousRoleResolutionType;
(function (AmbiguousRoleResolutionType) {
    AmbiguousRoleResolutionType["AUTHENTICATED_ROLE"] = "AuthenticatedRole";
    AmbiguousRoleResolutionType["DENY"] = "Deny";
})(AmbiguousRoleResolutionType || (AmbiguousRoleResolutionType = {}));
export var CognitoIdentityProvider;
(function (CognitoIdentityProvider) {
    CognitoIdentityProvider.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CognitoIdentityProvider.isa = function (o) { return __isa(o, "CognitoIdentityProvider"); };
})(CognitoIdentityProvider || (CognitoIdentityProvider = {}));
export var ConcurrentModificationException;
(function (ConcurrentModificationException) {
    ConcurrentModificationException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ConcurrentModificationException.isa = function (o) { return __isa(o, "ConcurrentModificationException"); };
})(ConcurrentModificationException || (ConcurrentModificationException = {}));
export var CreateIdentityPoolInput;
(function (CreateIdentityPoolInput) {
    CreateIdentityPoolInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreateIdentityPoolInput.isa = function (o) { return __isa(o, "CreateIdentityPoolInput"); };
})(CreateIdentityPoolInput || (CreateIdentityPoolInput = {}));
export var Credentials;
(function (Credentials) {
    Credentials.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Credentials.isa = function (o) { return __isa(o, "Credentials"); };
})(Credentials || (Credentials = {}));
export var DeleteIdentitiesInput;
(function (DeleteIdentitiesInput) {
    DeleteIdentitiesInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteIdentitiesInput.isa = function (o) { return __isa(o, "DeleteIdentitiesInput"); };
})(DeleteIdentitiesInput || (DeleteIdentitiesInput = {}));
export var DeleteIdentitiesResponse;
(function (DeleteIdentitiesResponse) {
    DeleteIdentitiesResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteIdentitiesResponse.isa = function (o) { return __isa(o, "DeleteIdentitiesResponse"); };
})(DeleteIdentitiesResponse || (DeleteIdentitiesResponse = {}));
export var DeleteIdentityPoolInput;
(function (DeleteIdentityPoolInput) {
    DeleteIdentityPoolInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteIdentityPoolInput.isa = function (o) { return __isa(o, "DeleteIdentityPoolInput"); };
})(DeleteIdentityPoolInput || (DeleteIdentityPoolInput = {}));
export var DescribeIdentityInput;
(function (DescribeIdentityInput) {
    DescribeIdentityInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DescribeIdentityInput.isa = function (o) { return __isa(o, "DescribeIdentityInput"); };
})(DescribeIdentityInput || (DescribeIdentityInput = {}));
export var DescribeIdentityPoolInput;
(function (DescribeIdentityPoolInput) {
    DescribeIdentityPoolInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DescribeIdentityPoolInput.isa = function (o) { return __isa(o, "DescribeIdentityPoolInput"); };
})(DescribeIdentityPoolInput || (DescribeIdentityPoolInput = {}));
export var DeveloperUserAlreadyRegisteredException;
(function (DeveloperUserAlreadyRegisteredException) {
    DeveloperUserAlreadyRegisteredException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeveloperUserAlreadyRegisteredException.isa = function (o) {
        return __isa(o, "DeveloperUserAlreadyRegisteredException");
    };
})(DeveloperUserAlreadyRegisteredException || (DeveloperUserAlreadyRegisteredException = {}));
export var ErrorCode;
(function (ErrorCode) {
    ErrorCode["ACCESS_DENIED"] = "AccessDenied";
    ErrorCode["INTERNAL_SERVER_ERROR"] = "InternalServerError";
})(ErrorCode || (ErrorCode = {}));
export var ExternalServiceException;
(function (ExternalServiceException) {
    ExternalServiceException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ExternalServiceException.isa = function (o) { return __isa(o, "ExternalServiceException"); };
})(ExternalServiceException || (ExternalServiceException = {}));
export var GetCredentialsForIdentityInput;
(function (GetCredentialsForIdentityInput) {
    GetCredentialsForIdentityInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetCredentialsForIdentityInput.isa = function (o) { return __isa(o, "GetCredentialsForIdentityInput"); };
})(GetCredentialsForIdentityInput || (GetCredentialsForIdentityInput = {}));
export var GetCredentialsForIdentityResponse;
(function (GetCredentialsForIdentityResponse) {
    GetCredentialsForIdentityResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetCredentialsForIdentityResponse.isa = function (o) { return __isa(o, "GetCredentialsForIdentityResponse"); };
})(GetCredentialsForIdentityResponse || (GetCredentialsForIdentityResponse = {}));
export var GetIdentityPoolRolesInput;
(function (GetIdentityPoolRolesInput) {
    GetIdentityPoolRolesInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetIdentityPoolRolesInput.isa = function (o) { return __isa(o, "GetIdentityPoolRolesInput"); };
})(GetIdentityPoolRolesInput || (GetIdentityPoolRolesInput = {}));
export var GetIdentityPoolRolesResponse;
(function (GetIdentityPoolRolesResponse) {
    GetIdentityPoolRolesResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetIdentityPoolRolesResponse.isa = function (o) { return __isa(o, "GetIdentityPoolRolesResponse"); };
})(GetIdentityPoolRolesResponse || (GetIdentityPoolRolesResponse = {}));
export var GetIdInput;
(function (GetIdInput) {
    GetIdInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetIdInput.isa = function (o) { return __isa(o, "GetIdInput"); };
})(GetIdInput || (GetIdInput = {}));
export var GetIdResponse;
(function (GetIdResponse) {
    GetIdResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetIdResponse.isa = function (o) { return __isa(o, "GetIdResponse"); };
})(GetIdResponse || (GetIdResponse = {}));
export var GetOpenIdTokenForDeveloperIdentityInput;
(function (GetOpenIdTokenForDeveloperIdentityInput) {
    GetOpenIdTokenForDeveloperIdentityInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetOpenIdTokenForDeveloperIdentityInput.isa = function (o) {
        return __isa(o, "GetOpenIdTokenForDeveloperIdentityInput");
    };
})(GetOpenIdTokenForDeveloperIdentityInput || (GetOpenIdTokenForDeveloperIdentityInput = {}));
export var GetOpenIdTokenForDeveloperIdentityResponse;
(function (GetOpenIdTokenForDeveloperIdentityResponse) {
    GetOpenIdTokenForDeveloperIdentityResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetOpenIdTokenForDeveloperIdentityResponse.isa = function (o) {
        return __isa(o, "GetOpenIdTokenForDeveloperIdentityResponse");
    };
})(GetOpenIdTokenForDeveloperIdentityResponse || (GetOpenIdTokenForDeveloperIdentityResponse = {}));
export var GetOpenIdTokenInput;
(function (GetOpenIdTokenInput) {
    GetOpenIdTokenInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetOpenIdTokenInput.isa = function (o) { return __isa(o, "GetOpenIdTokenInput"); };
})(GetOpenIdTokenInput || (GetOpenIdTokenInput = {}));
export var GetOpenIdTokenResponse;
(function (GetOpenIdTokenResponse) {
    GetOpenIdTokenResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetOpenIdTokenResponse.isa = function (o) { return __isa(o, "GetOpenIdTokenResponse"); };
})(GetOpenIdTokenResponse || (GetOpenIdTokenResponse = {}));
export var IdentityDescription;
(function (IdentityDescription) {
    IdentityDescription.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    IdentityDescription.isa = function (o) { return __isa(o, "IdentityDescription"); };
})(IdentityDescription || (IdentityDescription = {}));
export var IdentityPool;
(function (IdentityPool) {
    IdentityPool.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    IdentityPool.isa = function (o) { return __isa(o, "IdentityPool"); };
})(IdentityPool || (IdentityPool = {}));
export var IdentityPoolShortDescription;
(function (IdentityPoolShortDescription) {
    IdentityPoolShortDescription.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    IdentityPoolShortDescription.isa = function (o) { return __isa(o, "IdentityPoolShortDescription"); };
})(IdentityPoolShortDescription || (IdentityPoolShortDescription = {}));
export var InternalErrorException;
(function (InternalErrorException) {
    InternalErrorException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    InternalErrorException.isa = function (o) { return __isa(o, "InternalErrorException"); };
})(InternalErrorException || (InternalErrorException = {}));
export var InvalidIdentityPoolConfigurationException;
(function (InvalidIdentityPoolConfigurationException) {
    InvalidIdentityPoolConfigurationException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    InvalidIdentityPoolConfigurationException.isa = function (o) {
        return __isa(o, "InvalidIdentityPoolConfigurationException");
    };
})(InvalidIdentityPoolConfigurationException || (InvalidIdentityPoolConfigurationException = {}));
export var InvalidParameterException;
(function (InvalidParameterException) {
    InvalidParameterException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    InvalidParameterException.isa = function (o) { return __isa(o, "InvalidParameterException"); };
})(InvalidParameterException || (InvalidParameterException = {}));
export var LimitExceededException;
(function (LimitExceededException) {
    LimitExceededException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    LimitExceededException.isa = function (o) { return __isa(o, "LimitExceededException"); };
})(LimitExceededException || (LimitExceededException = {}));
export var ListIdentitiesInput;
(function (ListIdentitiesInput) {
    ListIdentitiesInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListIdentitiesInput.isa = function (o) { return __isa(o, "ListIdentitiesInput"); };
})(ListIdentitiesInput || (ListIdentitiesInput = {}));
export var ListIdentitiesResponse;
(function (ListIdentitiesResponse) {
    ListIdentitiesResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListIdentitiesResponse.isa = function (o) { return __isa(o, "ListIdentitiesResponse"); };
})(ListIdentitiesResponse || (ListIdentitiesResponse = {}));
export var ListIdentityPoolsInput;
(function (ListIdentityPoolsInput) {
    ListIdentityPoolsInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListIdentityPoolsInput.isa = function (o) { return __isa(o, "ListIdentityPoolsInput"); };
})(ListIdentityPoolsInput || (ListIdentityPoolsInput = {}));
export var ListIdentityPoolsResponse;
(function (ListIdentityPoolsResponse) {
    ListIdentityPoolsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListIdentityPoolsResponse.isa = function (o) { return __isa(o, "ListIdentityPoolsResponse"); };
})(ListIdentityPoolsResponse || (ListIdentityPoolsResponse = {}));
export var ListTagsForResourceInput;
(function (ListTagsForResourceInput) {
    ListTagsForResourceInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListTagsForResourceInput.isa = function (o) { return __isa(o, "ListTagsForResourceInput"); };
})(ListTagsForResourceInput || (ListTagsForResourceInput = {}));
export var ListTagsForResourceResponse;
(function (ListTagsForResourceResponse) {
    ListTagsForResourceResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListTagsForResourceResponse.isa = function (o) { return __isa(o, "ListTagsForResourceResponse"); };
})(ListTagsForResourceResponse || (ListTagsForResourceResponse = {}));
export var LookupDeveloperIdentityInput;
(function (LookupDeveloperIdentityInput) {
    LookupDeveloperIdentityInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    LookupDeveloperIdentityInput.isa = function (o) { return __isa(o, "LookupDeveloperIdentityInput"); };
})(LookupDeveloperIdentityInput || (LookupDeveloperIdentityInput = {}));
export var LookupDeveloperIdentityResponse;
(function (LookupDeveloperIdentityResponse) {
    LookupDeveloperIdentityResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    LookupDeveloperIdentityResponse.isa = function (o) { return __isa(o, "LookupDeveloperIdentityResponse"); };
})(LookupDeveloperIdentityResponse || (LookupDeveloperIdentityResponse = {}));
export var MappingRule;
(function (MappingRule) {
    MappingRule.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    MappingRule.isa = function (o) { return __isa(o, "MappingRule"); };
})(MappingRule || (MappingRule = {}));
export var MappingRuleMatchType;
(function (MappingRuleMatchType) {
    MappingRuleMatchType["CONTAINS"] = "Contains";
    MappingRuleMatchType["EQUALS"] = "Equals";
    MappingRuleMatchType["NOT_EQUAL"] = "NotEqual";
    MappingRuleMatchType["STARTS_WITH"] = "StartsWith";
})(MappingRuleMatchType || (MappingRuleMatchType = {}));
export var MergeDeveloperIdentitiesInput;
(function (MergeDeveloperIdentitiesInput) {
    MergeDeveloperIdentitiesInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    MergeDeveloperIdentitiesInput.isa = function (o) { return __isa(o, "MergeDeveloperIdentitiesInput"); };
})(MergeDeveloperIdentitiesInput || (MergeDeveloperIdentitiesInput = {}));
export var MergeDeveloperIdentitiesResponse;
(function (MergeDeveloperIdentitiesResponse) {
    MergeDeveloperIdentitiesResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    MergeDeveloperIdentitiesResponse.isa = function (o) { return __isa(o, "MergeDeveloperIdentitiesResponse"); };
})(MergeDeveloperIdentitiesResponse || (MergeDeveloperIdentitiesResponse = {}));
export var NotAuthorizedException;
(function (NotAuthorizedException) {
    NotAuthorizedException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    NotAuthorizedException.isa = function (o) { return __isa(o, "NotAuthorizedException"); };
})(NotAuthorizedException || (NotAuthorizedException = {}));
export var ResourceConflictException;
(function (ResourceConflictException) {
    ResourceConflictException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ResourceConflictException.isa = function (o) { return __isa(o, "ResourceConflictException"); };
})(ResourceConflictException || (ResourceConflictException = {}));
export var ResourceNotFoundException;
(function (ResourceNotFoundException) {
    ResourceNotFoundException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ResourceNotFoundException.isa = function (o) { return __isa(o, "ResourceNotFoundException"); };
})(ResourceNotFoundException || (ResourceNotFoundException = {}));
export var RoleMapping;
(function (RoleMapping) {
    RoleMapping.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    RoleMapping.isa = function (o) { return __isa(o, "RoleMapping"); };
})(RoleMapping || (RoleMapping = {}));
export var RoleMappingType;
(function (RoleMappingType) {
    RoleMappingType["RULES"] = "Rules";
    RoleMappingType["TOKEN"] = "Token";
})(RoleMappingType || (RoleMappingType = {}));
export var RulesConfigurationType;
(function (RulesConfigurationType) {
    RulesConfigurationType.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    RulesConfigurationType.isa = function (o) { return __isa(o, "RulesConfigurationType"); };
})(RulesConfigurationType || (RulesConfigurationType = {}));
export var SetIdentityPoolRolesInput;
(function (SetIdentityPoolRolesInput) {
    SetIdentityPoolRolesInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SetIdentityPoolRolesInput.isa = function (o) { return __isa(o, "SetIdentityPoolRolesInput"); };
})(SetIdentityPoolRolesInput || (SetIdentityPoolRolesInput = {}));
export var TagResourceInput;
(function (TagResourceInput) {
    TagResourceInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    TagResourceInput.isa = function (o) { return __isa(o, "TagResourceInput"); };
})(TagResourceInput || (TagResourceInput = {}));
export var TagResourceResponse;
(function (TagResourceResponse) {
    TagResourceResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    TagResourceResponse.isa = function (o) { return __isa(o, "TagResourceResponse"); };
})(TagResourceResponse || (TagResourceResponse = {}));
export var TooManyRequestsException;
(function (TooManyRequestsException) {
    TooManyRequestsException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    TooManyRequestsException.isa = function (o) { return __isa(o, "TooManyRequestsException"); };
})(TooManyRequestsException || (TooManyRequestsException = {}));
export var UnlinkDeveloperIdentityInput;
(function (UnlinkDeveloperIdentityInput) {
    UnlinkDeveloperIdentityInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UnlinkDeveloperIdentityInput.isa = function (o) { return __isa(o, "UnlinkDeveloperIdentityInput"); };
})(UnlinkDeveloperIdentityInput || (UnlinkDeveloperIdentityInput = {}));
export var UnlinkIdentityInput;
(function (UnlinkIdentityInput) {
    UnlinkIdentityInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UnlinkIdentityInput.isa = function (o) { return __isa(o, "UnlinkIdentityInput"); };
})(UnlinkIdentityInput || (UnlinkIdentityInput = {}));
export var UnprocessedIdentityId;
(function (UnprocessedIdentityId) {
    UnprocessedIdentityId.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UnprocessedIdentityId.isa = function (o) { return __isa(o, "UnprocessedIdentityId"); };
})(UnprocessedIdentityId || (UnprocessedIdentityId = {}));
export var UntagResourceInput;
(function (UntagResourceInput) {
    UntagResourceInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UntagResourceInput.isa = function (o) { return __isa(o, "UntagResourceInput"); };
})(UntagResourceInput || (UntagResourceInput = {}));
export var UntagResourceResponse;
(function (UntagResourceResponse) {
    UntagResourceResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UntagResourceResponse.isa = function (o) { return __isa(o, "UntagResourceResponse"); };
})(UntagResourceResponse || (UntagResourceResponse = {}));
//# sourceMappingURL=index.js.map